import { axiosClient } from "$/http"

import { EAuthMutationUrl } from "./auth.api.config"
import type {
    TLoginMutationPayload,
    TLoginMutationResponse,
    TPassMutationPayload,
    TPassMutationResponse,
    TSsoMutationResponse
} from "./auth.api.types"

async function login(params: TLoginMutationPayload): Promise<TLoginMutationResponse> {
    return axiosClient.post(EAuthMutationUrl.Login(), params)
}

async function pass(params: TPassMutationPayload): Promise<TPassMutationResponse> {
    return axiosClient.post(EAuthMutationUrl.Pass(params.registration_key), params)
}

async function sso(email: string): Promise<TSsoMutationResponse> {
    return axiosClient.post(EAuthMutationUrl.SSO(), email)
}

const mutators = { login, pass, sso }

export { mutators as authMutationsMutators }
